<template>
  <n-message-provider>
    <n-dialog-provider>
      <n-notification-provider>
        <a-config-provider :theme="antDesignLightTheme">
          <router-view />
        </a-config-provider>
      </n-notification-provider>
    </n-dialog-provider>
  </n-message-provider>
</template>

<script setup lang="ts">
import { NMessageProvider, NDialogProvider, NNotificationProvider } from 'naive-ui';
import { antDesignLightTheme } from '@/assets/tokens/antd-theme';
</script>

<style scoped>
/* Root component styles */
</style>
